/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"


const Video = ({ videoLink, businessName }) => {

  return (
    <>
      <section className="main-video">
        <div className="sub-video-section" data-video-type="youtube" data-video-title="" data-video-id={videoLink} data-video-autoplay="1">
          <div className="video-page" style={{ width: '1920.06px', height: '684.021px', top: '0px', left: '-28.5186px' }}>
            <iframe
              frameborder="0"
              allowfullscreen=""
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              title={businessName}
              width="100%"
              height="100%"
              src={`https://www.youtube.com/embed/${videoLink}?autoplay=1&amp;loop=1&amp;&mute=1&amp;controls=0&amp;showinfo=0&amp;autohide=1&amp;rel=0&amp;modestbranding=1&amp;hd=1&amp;playsinline=1&amp;iv_load_policy=3&amp;enablejsapi=1`}
              data-gtm-yt-inspected-9="true"
            >
            </iframe>
          </div>
        </div>
      </section>
    </>
  );
};

export default Video;
